import React from "react";
import "../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import ScholarshipsRecessesForm from "./ScholarshipsRecessesForm";
import Transition from "components/layout/transition/Transition";
import { useQueryGetScholarshipHistory } from "../../../hooks/DataFetching/HR/ScholarshipRecesses/useQueryGetScholarshipHistory";
import { useQueryGetUserRuleset } from "../../../hooks/DataFetching/HR/ScholarshipRecesses/useQueryGetUserRuleset";
import { Redirect } from "react-router-dom";

const CallViewMyRecesses = () => {
  if (localStorage.getItem("auth-token") !== null) {
    var auth = JSON.parse(localStorage.getItem("auth-token"));
  }

  const rulesetData = useQueryGetUserRuleset(auth.id).data;
  const { isFetching, isSuccess, data } = useQueryGetScholarshipHistory(
    auth.id
  );

  if (isSuccess) {
    if (rulesetData !== "Bolsista") {
      return (
        <Transition loading={isFetching} newDesign>
          <Redirect to={{ pathname: "/forbidden" }} />
        </Transition>
      );
    }
  }

  return (
    <div>
      <DashboardNavBar />
      <SideBar />
      <Transition loading={isFetching} newDesign>
        <ScholarshipsRecessesForm
          context={"view"}
          myRecesses={true}
          scholarshipRecessHistory={data}
          loading={isFetching}
          isSuccess={isSuccess}
        />
      </Transition>
    </div>
  );
};

export default CallViewMyRecesses;
